<template>
    <div id="video-header">
        <header>
            <!-- This div is  intentionally blank. It creates the transparent black overlay over the video which you can modify in the CSS -->
<!--            <div class="overlay"></div>-->

            <!-- The HTML5 video element that will create the background video on the header -->
            <video playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop">
                <source src="/video/private_gym_intro_1080p.mp4" type="video/mp4">
            </video>

            <!-- The header content -->
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <frontpage-carousel-item></frontpage-carousel-item>
                </div>
            </div>
        </header>
    </div>
</template>

<script>

import FrontpageCarouselItem from "./FrontpageCarouselItem";
export default {
    components: {FrontpageCarouselItem},

    props: [],

    mixins: [],

    data: function () {
        return {
            //
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
<style lang="scss">

    #video-header {
        header {
            position: relative;
            background-color: black;
            height: 75vh;
            min-height: 25rem;
            width: 100%;
            overflow: hidden;
        }

        header video {
            position: absolute;
            top: 50%;
            left: 50%;
            min-width: 100%;
            min-height: 100%;
            width: auto;
            height: auto;
            z-index: 0;
            -ms-transform: translateX(-50%) translateY(-50%);
            -moz-transform: translateX(-50%) translateY(-50%);
            -webkit-transform: translateX(-50%) translateY(-50%);
            transform: translateX(-50%) translateY(-50%);
        }

        header .container {
            position: relative;
            z-index: 2;
        }

        header .overlay {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: black;
            opacity: 0.5;
            z-index: 1;
        }

        /* Media Query for devices withi coarse pointers and no hover functionality */
        /* This will use a fallback image instead of a video for devices that commonly do not support the HTML5 video element */
        //@media (pointer: coarse) and (hover: none) {
        //    header {
        //        background: url('/images/gym/7.jpeg') black no-repeat center center scroll;
        //    }
        //
        //    header video {
        //        display: none;
        //    }
        //}
    }

</style>
